import { createIcon } from '@chakra-ui/react';

export const HamMenu = createIcon({
  displayName: 'HamMenu',
  viewBox: '0 0 24 24',
  path: (
    <path
      id="Menu_-_L-2"
      data-name="Menu - L"
      d="M1.967,12.524H23.033a.762.762,0,1,0,0-1.524H1.967a.762.762,0,1,0,0,1.524Zm0-5.253H23.033a.762.762,0,1,0,0-1.524H1.967a.762.762,0,1,0,0,1.524Zm0-5.257H23.033a.762.762,0,1,0,0-1.524H1.967a.762.762,0,1,0,0,1.524Zm21.867,16.6v3.73a1.537,1.537,0,0,1-3.074,0v-3.73h-.667V22.4A2.043,2.043,0,0,0,22.31,24.49,2.023,2.023,0,0,0,24.5,22.4V18.616Zm-20.19,3.81-.324.735L2.991,22.4l-1.7-3.81H.5V24.4h.632V19.663l.32.777,1.585,3.55h.522l1.592-3.55.35-.792v4.739h.651V18.616H5.334Zm13.89.522v.545l-.358-.545-2.96-4.331h-.7V24.4h.625v-4.88l.381.571L17.452,24.4h.7V18.616h-.644Zm-8.7-1.28h2.415V21.1H8.828v-1.9h3.158v-.575H8.176V24.4h3.859v-.56H8.828Z"
      transform="translate(-0.5 -0.49)"
      fill="currentColor"
    />
  ),
});
